<template>
  <DiagnosisCard
    heading="資産運用の割合"
    annotation="※資産運用の合計額÷金融資産の保有額"
    :text="text"
  >
    <template #content>
      <section :class="$style.wrapper">
        <p :class="$style.nickname">お客様</p>
        <RatioBar :ratio="userInvestmentRatio" />
        <div :class="$style.underline">
          <div :class="$style.underline__line" />
          <p :class="$style.underline__text">金融資産の保有額</p>
          <div :class="$style.underline__line" />
        </div>
      </section>
    </template>
  </DiagnosisCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import DiagnosisCard from '@/components/molecules/DiagnosisCard.vue'
import RatioBar from './RatioBar.vue'

const props = defineProps<{
  investment: number
  savings: number
  text: string
}>()

const userInvestmentRatio = computed(() =>
  props.investment === 0
    ? 0
    : Math.round((props.investment / (props.savings + props.investment)) * 100)
)
</script>

<style lang="scss" module>
.wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nickname {
  font-size: 12px;
  font-weight: bold;
}

.underline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  &__line {
    width: 100%;
    height: 1px;
    border: 0.5px dashed $color-border-medium-emphasis;
  }

  &__text {
    font-size: 10px;
    white-space: nowrap;
    color: $color-text-and-object-medium-emphasis;
  }
}
</style>
